<div class="app-launcher-wrapper">
  <!-- 9-dot trigger button -->
  <button mat-icon-button class="launcher-btn" aria-label="Open app launcher" (click)="toggle()" [class.active]="isOpen">
    <svg class="dots-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
      <circle cx="3"  cy="3"  r="2"/>
      <circle cx="10" cy="3"  r="2"/>
      <circle cx="17" cy="3"  r="2"/>
      <circle cx="3"  cy="10" r="2"/>
      <circle cx="10" cy="10" r="2"/>
      <circle cx="17" cy="10" r="2"/>
      <circle cx="3"  cy="17" r="2"/>
      <circle cx="10" cy="17" r="2"/>
      <circle cx="17" cy="17" r="2"/>
    </svg>
  </button>

  @if (isOpen) {
    <div class="launcher-panel" role="dialog" aria-label="App launcher">
      <div class="panel-section-label">Modules</div>
      <div class="launcher-grid">
        @for (item of visibleModules; track item.label) {
          <button
            class="launcher-item"
            [class.disabled]="item.disabled"
            [attr.aria-disabled]="item.disabled"
            (click)="navigate(item)"
            [attr.title]="item.label"
          >
            <div class="launcher-icon-wrap">
              <mat-icon>{{ item.icon }}</mat-icon>
            </div>
            <span>{{ item.label }}</span>
          </button>
        }
      </div>

      @if (visibleAdminModules.length) {
        <mat-divider></mat-divider>

        <div class="panel-section-label">Administration</div>
        <div class="launcher-grid">
          @for (item of visibleAdminModules; track item.label) {
            <button
              class="launcher-item"
              [class.disabled]="item.disabled"
              [attr.aria-disabled]="item.disabled"
              (click)="navigate(item)"
              [attr.title]="item.label"
            >
              <div class="launcher-icon-wrap">
                <mat-icon>{{ item.icon }}</mat-icon>
                <mat-icon class="admin-badge" title="Admin">lock</mat-icon>
              </div>
              <span>{{ item.label }}</span>
            </button>
          }
        </div>
      }

      <!-- TODO: Move sibling apps configuration to the database
      <mat-divider></mat-divider>

      <div class="panel-section-label">Sibling Apps</div>
      <div class="launcher-grid sibling-grid">
        @for (item of visibleSiblingApps; track item.label) {
          <button
            class="launcher-item"
            (click)="navigate(item)"
            [attr.title]="item.label"
          >
            <div class="launcher-icon-wrap">
              <mat-icon>{{ item.icon }}</mat-icon>
              <mat-icon class="external-badge">open_in_new</mat-icon>
            </div>
            <span>{{ item.label }}</span>
          </button>
        }
      </div>
      -->
    </div>
  }
</div>
